// In framework/client/widgets/AIMetricsByModelWidget.widget.js

export default {
    name: "AIMetricsByModelWidget",
    type: "DataWidget",
    description: "Displays detailed AI usage metrics (tokens, cost) grouped by model.",
    roles: ["admin"],
    widget: {
        title: "AI Metrics by Model",
        size: "large",

        // --- FIX: Use the new dataProvider format ---
        dataProvider: {
            main: {
                rpc: "AdminAnalyticsRpc.getUsageData",
                params: {
                    groupBy: "model",
                }
            }
        },

        viewMode: "list",
        fields: [
            { name: "model", label: "Model", icon: "bi bi-cpu-fill", render: (val) => `<strong class="text-primary">${val}</strong>` },
            { name: "requestCount", label: "Requests", format: "number", icon: "bi bi-arrow-repeat" },
            { name: "totalPromptTokens", label: "Prompt Tokens", format: "number", icon: "bi bi-input-cursor-text" },
            { name: "totalCompletionTokens", label: "Completion Tokens", format: "number", icon: "bi bi-chat-left-text-fill" },
            { name: "totalTokens", label: "Total Tokens", format: "number", icon: "bi bi-memory" },
            { name: "totalCost", label: "Est. Cost", format: "currency", icon: "bi bi-currency-dollar" },
            { name: "errorCount", label: "Errors", icon: "bi bi-exclamation-triangle-fill", render: (val) => val > 0 ? `<span class="badge bg-danger">${val}</span>` : `<span class="badge bg-success">${val}</span>` }
        ],
        noDataMessage: "No model usage data to display for the selected period."
    }
};